import { IntlProvider, FormattedMessage } from "react-intl";
export const realEstateConstant = () => {
  return {
    QUOTE1: <FormattedMessage id="quotes.marketplace.title" />,
    QUOTE2: <FormattedMessage id="quotes.realestate.home" />,
    LOGO_URL: "../assets/RealEstate.png",
  };
};
